import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutSalesCallMultiSelectErrorModel extends Layout {
    labelErrorLink: Label;
    labelErrorPipe: Label;
    labelFailedLink: Label;
    labelFailedOrderCount: Label;
    labelFailedOrders: Label;
    labelFailedPipe: Label;
    labelStatus: Label;
    labelSuccessfulOrderCount: Label;
    labelSuccessfulOrders: Label;
    panelFailed: Panel;
    panelSuccess: Panel;
}
